import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconInfoRoundedOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="currentColor"><path d="M16 2c7.72 0 14 6.28 14 14s-6.28 14-14 14S2 23.72 2 16 8.28 2 16 2m0-2C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0" /><path fillRule="evenodd" d="M17.3 9.64c0 .72-.58 1.3-1.3 1.3s-1.3-.58-1.3-1.3.58-1.3 1.3-1.3 1.3.58 1.3 1.3" clipRule="evenodd" /><path d="M16 24c-.56 0-1-.44-1-1v-9.1c0-.56.44-1 1-1s1 .44 1 1V23c0 .56-.44 1-1 1" /></g></svg>;
export default SvgIconInfoRoundedOutlined;